app.service('stringHelper', [function () {
  const stringHelperService = this;

  stringHelperService.isNullOrEmpty = function (value) {
    return (value === '' || value === null || value === undefined);
  };

  stringHelperService.isHtmlEmpty = function (value) {
    if (stringHelperService.isNullOrEmpty(value)) return true;
    const text = value.replaceAll(/<[^>]{0,500}>/g, '').replaceAll('&nbsp;', ' ').trim();
    return text.length === 0;
  };
}]);
